import { useLazyQuery } from '@apollo/client/react';

import { getLocalSessionAddress } from '../query';

const useLocalSessionAddress = () => {
  const [getAddress, { loading, error, data }] = useLazyQuery(
    getLocalSessionAddress
  );

  return { loading, error, addressData: data, getAddress };
};

export { useLocalSessionAddress };
